import Button from '@components/button';
import Checkbox from '@components/checkbox';
import Modal from '@components/modal';
import { Form } from '@components/ui';
import { useDocuments } from '@hooks/app/useDocuments';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { initialValues, validationSchema } from './role-terms-modal.schema';
import { ModalContentSC } from './role-terms-modal.styled';

interface RoleTermsModalProps {
  onClose?: () => void;
  onSubmit?: () => void;
  visible?: boolean;
}

const RoleTermsModal: React.FunctionComponent<RoleTermsModalProps> = ({
  visible,
  onClose,
  onSubmit,
}) => {
  const { documents, loading: documentsLoading } = useDocuments();
  const [form, formOptions] = Form.useForm({
    initialValues,
    validationSchema,
    onSubmit: () => {
      onSubmit?.();
    },
  });

  React.useLayoutEffect(() => {
    if (visible) {
      form?.resetForm?.();
    }
  }, [visible, form]);

  return (
    <Modal isOpen={visible ?? false}>
      <ModalContentSC>
        <Form {...formOptions} showFeedback={false}>
          <div className="title">
            <FormattedMessage id={'reg.step_3.terms_modal.title'} />
          </div>
          <div className="sub-title">
            <FormattedMessage id="reg.step_3.terms_modal.description" />
          </div>
          <div className="modal-content">
            <Form.Field name="termsDoctor">
              <Checkbox>
                <FormattedMessage
                  id="reg.step_3.terms_modal.vop"
                  values={{
                    // @ts-expect-error
                    a: (ch) => (
                      <a href={documents?.['vop-doctor'].file} target="_blank" rel="noreferrer">
                        {ch}
                      </a>
                    ),
                  }}
                />
              </Checkbox>
            </Form.Field>
          </div>
          <div className="actions-wrapper">
            <Button isBlock kind="SECONDARY" onClick={onClose}>
              <FormattedMessage id="reg.step_3.terms_modal.submit_action" />
            </Button>
            <Button
              kind="PRIMARY"
              isBlock
              disabled={documentsLoading || !documents}
              htmlType="submit"
            >
              <FormattedMessage id="reg.step_3.terms_modal.cancel_action" />
            </Button>
          </div>
        </Form>
      </ModalContentSC>
    </Modal>
  );
};

export default React.memo(RoleTermsModal);
